import { render } from "./inboxReports.vue?vue&type=template&id=2c362dc2"
import script from "./inboxReports.vue?vue&type=script&lang=js"
export * from "./inboxReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__